import Vue from 'vue';

const selector = '[data-vc="footer"]';

document.addEventListener('DOMContentLoaded', () => {
    new Vue({
        delimiters: ["<%", "%>"],
    }).$mount(selector);
});
